import { MenuProps } from 'antd'
import UploadedFile from '../../types/api/uploaded-file'

interface UseBlankPreviewSelectionParams {
    blankPreviewFiles?: UploadedFile[]
    onSelect: (previewIndex: number) => void | Promise<void>
}

interface UseBlankPreviewSelectionResult {
    count: number
    menuItems?: MenuProps['items']
    runSingle: () => void | Promise<void>
}

export default function useBlankPreviewSelection({
    blankPreviewFiles,
    onSelect,
}: UseBlankPreviewSelectionParams): UseBlankPreviewSelectionResult {
    const count = blankPreviewFiles?.length ?? 0

    const runAll = async () => {
        for (let index = 0; index < count; index++) {
            await onSelect(index)
        }
    }

    const menuItems: MenuProps['items'] | undefined =
        count > 1
            ? [
                  ...Array.from({ length: count }, (_, index) => ({
                      key: String(index),
                      label: `Дизайн ${index + 1}`,
                      onClick: () => onSelect(index),
                  })),
                  { type: 'divider' as const },
                  { key: 'all', label: 'Все', onClick: () => void runAll() },
              ]
            : undefined

    return {
        count,
        menuItems,
        runSingle: () => onSelect(0),
    }
}
